import { render, staticRenderFns } from "./BarcodeOrderViewModal.vue?vue&type=template&id=2a1439a1&scoped=true"
import script from "./BarcodeOrderViewModal.vue?vue&type=script&lang=ts"
export * from "./BarcodeOrderViewModal.vue?vue&type=script&lang=ts"
import style0 from "./BarcodeOrderViewModal.vue?vue&type=style&index=0&id=2a1439a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1439a1",
  null
  
)

export default component.exports